<template>
  <modal
    max-width="500"
    :value="value"
    @input="$emit('input', $event)"
  >
    <template #title>Download Reference Files</template>
    <template #content>
      <reference-file-download-list
        v-model="selected"
        data-testid="reference-file-download-list"
        :relevant-count="relevantCount"
        :not-relevant-count="notRelevantCount"
        :not-sure-count="notSureCount"
        :unscreened-count="unscreenedCount"
        :review="review"
      />
    </template>
    <template #actions>
      <action-button
        data-testid="cancel-button"
        class="mr-2"
        @click="$emit('input', false)"
      >
        Cancel
      </action-button>
      <action-button
        data-testid="download-button"
        color="success"
        width="130"
        :disabled="disableDownload"
        @click="onDownload"
      >
        <template v-if="downloading">
          <v-progress-circular
            class="mx-2"
            indeterminate
            size="25"
            width="2"
          />
        </template>
        <template v-else>
          <v-icon left class="material-icons-outlined">
            download
          </v-icon>
          Download
        </template>
      </action-button>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/Common/Modal';
import ActionButton from '@/components/Common/ActionButton';
import ReferenceFileDownloadList from './ReferenceFileDownloadList';
import { RelevanceAssessment } from '@/enums';
import { Review } from '@/models';

const labelToProp = {
  [RelevanceAssessment.RELEVANT]: 'relevantCount',
  [RelevanceAssessment.NOT_RELEVANT]: 'notRelevantCount',
  [RelevanceAssessment.NOT_SURE]: 'notSureCount',
  [RelevanceAssessment.UNSCREENED]: 'unscreenedCount',
};

export default {
  name: 'ReferenceFileDownloadDialog',
  components: { Modal, ActionButton, ReferenceFileDownloadList },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    relevantCount: {
      type: Number,
      default: 0,
    },
    notRelevantCount: {
      type: Number,
      default: 0,
    },
    notSureCount: {
      type: Number,
      default: 0,
    },
    unscreenedCount: {
      type: Number,
      default: 0,
    },
    review: {
      type: Review,
      default: null,
    },
  },
  data: () => ({
    selected: [],
    downloading: false,
  }),
  computed: {
    disableDownload() {
      return this.selected.length === 0;
    },
    availableOptions() {
      return Object.keys(RelevanceAssessment).filter(
        (label) => this[labelToProp[label]] > 0
      );
    },
  },
  watch: {
    value: function (showing) {
      if (showing) {
        this.reset();
      }
    },
  },
  mounted() {
    this.reset();
  },
  methods: {
    reset() {
      this.downloading = false;
      this.selectFirst();
    },
    selectFirst() {
      this.selected = [this.availableOptions[0]];
    },
    onDownload() {
      this.downloading = true;
      this.$emit('download', this.selected);
    },
  },
};
</script>
